import { MessageCircle } from 'lucide-react';

export default function FloatingWhatsApp({ onClick }) {
  return (
    <button
      data-testid="whatsapp-floating-button"
      onClick={onClick}
      aria-label="Atendimento pelo WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-mk-green text-white shadow-xl shadow-mk-green/40 transition-transform duration-300 hover:scale-110"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-mk-green/40 [animation-duration:2.5s]" />
      <MessageCircle size={26} strokeWidth={2.2} className="relative" />
    </button>
  );
}
